import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelopeCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";

import { useTranslation } from "react-i18next";

import "../scss/_submission.scss";

function Submission() {
    const navigate = useNavigate();
    const goHome = () => {
        navigate("/");
    };

    const { t } = useTranslation();

    return (
        <div className="submission">
            <div className="submission-icon">
                <FontAwesomeIcon icon={faEnvelopeCircleCheck} />
            </div>
            <div className="submission-text">
                <h1>{t("subissionConfirmation")}</h1>
                <p>{t("submissionThankYou")}</p>
            </div>
            <motion.button className="submission-button" whileHover={{ scale: 1.05 }} onClick={goHome}>
                {t("backToHome")}
            </motion.button>
        </div>
    );
}

export default Submission;